import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCompress, faExpand } from '@fortawesome/pro-solid-svg-icons';
import { faSignOut } from '@fortawesome/pro-regular-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';

import Shadow from 'components/shadow_grid/shadow';

import './styles.scss';

export default function ShadowEditor({
  canExportShadows,
  context,
  shadow,
  shadowInputOverridesUrl,
  shadowStylesheetUrl,
  onExit
}) {
  const [fullscreen, setFullscreen] = useState();
  const [showTestShadowEditor, setShowTestShadowEditor] = useState(false);

  useEffect(() => {
    function handleShowTestShadowEditorChange(event) {
      if (event.data.type === 'shadow.showTestShadowEditorChanged') {
        setShowTestShadowEditor(event.data.showTestShadowEditor);
      }
    }

    window.addEventListener('message', handleShowTestShadowEditorChange);
    return () => window.removeEventListener('message', handleShowTestShadowEditorChange);
  }, []);

  return (
    <div className="shadow-editor">
      <div className={classNames('shadow-wrapper', { fullscreen })} name="wrapper">
        <div className="shadow-toolbar">
          {!showTestShadowEditor && (
            <div className="shadow-sidebar">
              <OverlayTrigger
                overlay={<Tooltip className="default-tooltip" id="tooltip-exit">Exit</Tooltip>}
                placement="left"
              >
                <div className="shadow-sidebar-item" name="exit" onClick={onExit}>
                  <FontAwesomeIcon icon={faSignOut} />
                </div>
              </OverlayTrigger>
              <OverlayTrigger
                overlay={<Tooltip className="default-tooltip" id="tooltip-full">Full Screen</Tooltip>}
                placement="left"
              >
                <div className="shadow-sidebar-item" name="fullscreen" onClick={() => setFullscreen(!fullscreen)}>
                  <FontAwesomeIcon icon={fullscreen ? faCompress : faExpand} />
                </div>
              </OverlayTrigger>
            </div>
          )}
        </div>

        <Shadow
          canExportShadows={canExportShadows}
          className="shadow"
          context={context}
          shadowInputOverridesUrl={shadowInputOverridesUrl}
          stylesheetUrl={shadowStylesheetUrl}
          url={shadow.url}
        />
      </div>
    </div>
  );
}

ShadowEditor.propTypes = {
  canExportShadows: PropTypes.bool,
  context: PropTypes.object,
  shadow: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired,
  shadowInputOverridesUrl: PropTypes.string,
  shadowStylesheetUrl: PropTypes.string,
  onExit: PropTypes.func.isRequired,
};
